import React from 'react';
import { getLink } from './links';
import { TFunction } from 'i18next';

import { error500Content } from './errorTemplates/error-500';
import { domainContent } from './errorTemplates/domain';
import { unsupportedBrowser } from './errorTemplates/unsupportedBrowser';
import { tooManyCookies } from './errorTemplates/tooManyCookies';
import { undocumented } from './errorTemplates/undocumented';

interface errorPageDataType {
  title: string;
  subtitle?: string;
  button?: string;
  buttonLink?: string;
  content?: (t: TFunction) => JSX.Element;
  code?: string;
  nonBranded?: boolean;
}

export const errorMapping: { [key: string]: errorPageDataType } = {
  '400': {
    title: 'editorx.error.400.title',
    subtitle: 'editorx.error.400.subtitle',
    code: '400',
    button: 'editorx.go-to-editorx',
    buttonLink: getLink('editorX'),
  },
  '401': {
    title: 'editorx.error.400.title',
    subtitle: 'editorx.error.400.subtitle',
    code: '401',
    button: 'editorx.go-to-editorx',
    buttonLink: getLink('editorX'),
  },
  '402': {
    title: 'editorx.error.400.title',
    subtitle: 'editorx.error.400.subtitle',
    code: '402',
  },
  '403': {
    title: 'editorx.error.403.title',
    code: '403',
    button: 'editorx.go-to-editorx',
    buttonLink: getLink('editorX'),
  },
  '403v2': {
    title: 'editorx.error.403.title',
    code: '403',
  },
  '404': {
    title: 'editorx.error.404.title',
    subtitle: 'editorx.error.404.subtitle',
    button: 'editorx.go-to-editorx',
    buttonLink: getLink('editorX'),
    code: '404',
  },

  'NotBranded': {
    title: 'editorx.error.400.title',
    subtitle: 'editorx.error.400.subtitle',
    code: '400',
    nonBranded: true
  },

  '404-NotBranded': {
    title: 'editorx.error.404.title',
    subtitle: 'editorx.error.404.subtitle.not-branded',
    code: '404',
    nonBranded: true
  },

  '413': {
    title: 'editorx.error.too-many-cookies.title',
    content: tooManyCookies,
  },

  '500': {
    title: 'editorx.error.500.title',
    subtitle: 'editorx.error.500.subtitle',
    content: error500Content,
    code: '500',
  },

  '501': {
    title: 'editorx.error.500.title',
    subtitle: 'editorx.error.500.subtitle',
    content: error500Content,
    code: '501',
  },
  '502': {
    title: 'editorx.error.500.title',
    subtitle: 'editorx.error.500.subtitle',
    content: error500Content,
    code: '502',
  },

  '503': {
    title: 'editorx.error.500.title',
    subtitle: 'editorx.error.500.subtitle',
    content: error500Content,
    code: '503',
  },

  '504': {
    title: 'editorx.error.500.title',
    subtitle: 'editorx.error.500.subtitle',
    content: error500Content,
    code: '504',
  },

  'ConnectYourDomain': {
    title: 'editorx.error.domain.title',
    content: domainContent,
  },

  'unsupportedBrowser': {
    title: 'editorx.error.old-browsers.title',
    subtitle: 'editorx.error.old-browsers.subtitle',
    content: unsupportedBrowser,
  },

  'PublishedButNotAvailable': {
    title: 'editorx.error.published-but-not-available.title',
  },

  'ConnectYourIP': {
    title: 'editorx.error.connect-ip.title',
    subtitle: 'editorx.error.connect-ip.subtitle',
    button: 'editorx.go-to-editorx',
    buttonLink: getLink('editorX'),
  },

  'inviteExpired': {
    title: 'editorx.error.invite-expired.title',
    subtitle: 'editorx.error.invite-expired.subtitle',
    button: 'editorx.go-to-editorx',
    buttonLink: getLink('editorX'),
  },

  'undocumentedError': {
    title: 'editorx.error.undocumented.title',
    content: undocumented,
  },

  default: {
    title: 'editorx.error-title',
    subtitle: 'editorx.error-subtitle',
    button: 'editorx.go-to-editorx',
    buttonLink: getLink('editorX'),
  },


};
